module.exports = "/_next/static/images/e1ad956b8ac3a2c3e3e9186d09de5759-woman-using-cellphone@2x.png";